import { useAppSelector } from '@shared/lib/redux'

import { toastListStore } from './redux-toast.slice'

export const useToastList = () => {
  return useAppSelector(toastListStore.selectors.selectToastList)
}
